import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { connect } from "scrivito"

import { ProductQuickInfos } from "entities/products/ui/product-quick-infos/ProductQuickInfos"

import { useProductPageContext } from "../context/ProductPageContext"

type ProductPageQuickInfosProps = Omit<
  React.ComponentPropsWithoutRef<"section">,
  "ref"
> & {
  productType: string
  parentProductType?: string
}

function ProductPageQuickInfosComponent({
  productType,
  parentProductType,
  className,
  ...rest
}: ProductPageQuickInfosProps) {
  const { t } = useTranslation()
  const { getQuickInfos } = useProductPageContext()
  const quickInfos = getQuickInfos({ productType, parentProductType })

  return (
    <ProductQuickInfos.Root quickInfos={quickInfos}>
      <section
        {...rest}
        className={classNames(
          "product-page__quick-infos product-quick-infos product-page__section card card--elevated",
          className
        )}
      >
        <div className="product-page__section-header">
          <h3 className="product-page__section-title">
            {t("Product.Information.GeneralProductInformation")}
          </h3>
          <ProductQuickInfos.CopyToClipboard />
        </div>
        <ProductQuickInfos.Content />

        <div className="product-page__section-footer">
          <ProductQuickInfos.CopyToClipboard />
        </div>
      </section>
    </ProductQuickInfos.Root>
  )
}

export const ProductPageQuickInfos = React.memo(
  connect(ProductPageQuickInfosComponent)
)
